// @theme component
import { dispatcher } from 'dispatcher';
import { useLocation } from 'react-router';
import { useLogout } from '@core/js/hooks/auth';
import { useDTAG } from '@theme/js/hooks/useDTAG';
import { isStickyGamesBtnShown } from './constants';
import { useShowAgain } from './hooks/useShowAgain';
import { useTranslations } from '@core/js/hooks/i18n';
import { clsx } from '@core/js/utils/classNames.util';
import React, { useState, useEffect, useCallback } from 'react';
import { storageService } from '@core/js/services/storage.service';
import { WebContent } from '@core/js/components/system/WebContent';

import style from './index.scss';

export const StickyGamesButton = () => {
    const [open, setOpen] = useState<boolean>(false);
    const [isShowAgain, setIsShowAgain] = useShowAgain();
    const logout = useLogout();
    const location = useLocation();
    const t = useTranslations('playtech.mobile.system.2FA.preferences.');

    const showStickyButton = useDTAG('DTAG_SHOW_STICKY_BUTTON')?.includes(location.pathname) || null;

    const clearChoiceByLogout = useCallback(() => {
        storageService.local.removeItem(isStickyGamesBtnShown);
    }, []);

    useEffect(() => {
        dispatcher.listen('auth:action:logout', clearChoiceByLogout);

        return () => {
            dispatcher.removeListener('auth:action:logout', clearChoiceByLogout);
        };
    }, [clearChoiceByLogout, isShowAgain, logout]);

    const togglePanel = () => setOpen(!open);
    const handleShowingAgainBtnClick = () => {
        storageService.local.setItem(isStickyGamesBtnShown, !isShowAgain);
        setIsShowAgain(false);
    };

    return Boolean(showStickyButton && isShowAgain) && (
        <div className={clsx([style.container, open && style.containerOpen])} data-launch-source="stickyButton">
            <div className={clsx([style.content, open && style.contentOpen])}>
                <div className={clsx([open && style.contentItemOpen])}>
                    <div className={style.gameItemsContainer}>
                        <WebContent id={'STICKY_BUTTON_GAMES'}/>
                    </div>
                </div>
                <button className={style.notShowButton} onClick={handleShowingAgainBtnClick}>
                    <p>{t('playtech.mobile.system.DoNotShowAgain')}</p>
                </button>
            </div>
            <div className={clsx([style.handler, open && style.handlerOpen])} onClick={togglePanel}>
                {open
                    ? <div className={style.closeBtn}> &times;</div>
                    : <div className={clsx([style.logo, 'cms_sticky-button__logo'])}></div>
                }
            </div>
        </div>
    );
};
